export const DEFAULT_LANGUAGE = "nl";
export const FALLBACK_LANGUAGE = "nl";
export const SUPPORTED_LANGUAGES = ["nl", "en", "de", "fr", "es", "se", "da"];
